import React from 'react'
import {Spin, Icon, notification} from 'antd'

Spin.setDefaultIndicator(<Icon type='loading'/>)

notification.config({
  duration: null
})
